import React from 'react';

const RoadmapCommand = () => {
  const phases = [
    {
      period: 'Q4 2024',
      title: 'Foundation Building',
      emoji: '🏗️',
      items: [
        'Launch AI Trader Platform Beta: Introducing our platform to a select group for initial feedback and testing.',
        'Begin AIDER Token Distribution: Commencing the distribution of AIDER tokens to early participants.',
        'Explore Potential Partnerships: Seeking strategic alliances to expand our ecosystem and enhance our offerings.'
      ]
    },
    {
      period: 'Q1 2025',
      title: 'Growth and Development',
      emoji: '🌱',
      items: [
        'Full Platform Launch: Officially launching the complete AI Trader platform to the public.',
        'Seek AIDER Token Listings on Exchanges: Listing AIDER tokens on major cryptocurrency exchanges for broader accessibility.',
        'Introduce Staking Program: Implementing a staking program to reward token holders and incentivize long-term commitment.'
      ]
    },
    {
      period: 'Q2 2025',
      title: 'Expansion Phase',
      emoji: '🔍',
      items: [
        'Develop Decentralized AI Training Network: Building a decentralized network for more efficient AI training.',
        'Design AI Trader Mobile App: Creating a mobile app to enhance user accessibility and engagement.',
        'Reach Out to Research Institutions: Establishing collaborations with academic and research institutions to drive innovation.'
      ]
    },
    {
      period: 'Q3 2025',
      title: 'Innovation Boost',
      emoji: '💡',
      items: [
        'Consider Implementing AI Model Marketplace: Evaluating the potential for a marketplace where AI models can be traded and shared.',
        'Explore AIDER Governance Options: Developing governance models for AIDER token holders to participate in decision-making.',
        'Plan First AI Trader Community Event: Organizing an event to connect with our community and showcase our progress.'
      ]
    },
    {
      period: 'Q4 2025',
      title: 'Scaling Up',
      emoji: '📈',
      items: [
        'Work on AI Trader Platform Upgrades: Implementing improvements and optimizations to enhance platform performance.',
        'Investigate AI Assistant Possibilities: Exploring the development of AI assistants within our ecosystem.',
        'Research Expansion Opportunities: Identifying and planning for new growth areas and market opportunities.'
      ]
    },
    {
      period: '2025+ ',
      title: 'Future Vision',
      emoji: '🔮',
      items: [
        'Explore Advanced AI Integrations: Investigating the integration of cutting-edge AI technologies into our platform.',
        'Consider Token Economic Adjustments: Assessing and refining our tokenomics to better align with market dynamics.',
        'Brainstorm Long-Term Project Applications: Developing ideas for future applications and innovations for AI Trader.'
      ]
    }
  ];

  return (
    <div className="overview-container">
      <pre className="ascii-art">
{`██████╗  ██████╗  █████╗ ██████╗ ███╗   ███╗ █████╗ ██████╗ 
██╔══██╗██╔═══██╗██╔══██╗██╔══██╗████╗ ████║██╔══██╗██╔══██╗
██████╔╝██║   ██║███████║██║  ██║██╔████╔██║███████║██████╔╝
██╔══██╗██║   ██║██╔══██║██║  ██║██║╚██╔╝██║██╔══██║██╔═══╝ 
██║  ██║╚██████╔╝██║  ██║██████╔╝██║ ╚═╝ ██║██║  ██║██║     
╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚═════╝ ╚═╝     ╚═╝╚═╝  ╚═╝╚═╝     `}
      </pre>
      
      <div className="content-box">
        <div className="box-header">
          🚀🚀 AI TRADER ROADMAP: Our Journey to Revolution! 🚀🚀
        </div>
        
        <div className="box-content">
          <p>
            Follow our strategic path to revolutionize AI trading. Each phase brings us closer to our vision of democratizing artificial intelligence.
          </p>
          
          {phases.map((phase, index) => (
            <section key={index} className="feature-section">
              <h3>{phase.emoji} {phase.period}: {phase.title}</h3>
              <ul className="phase-items">
                {phase.items.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            </section>
          ))}

          <div className="disclaimer">
            Note: Roadmap milestones are subject to change based on market conditions and technological advancements.
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoadmapCommand;